<div
  class="severity-bar escape-margin"
  [style.background-color]="barColor"
  [style.color]="textColor"
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="8px"
  [matTooltip]="severityDescription">
  <div class="severity-number">{{ severityNumber }}</div>
  <div class="severity-text">{{ severityText }}</div>
</div>
